import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CsIconModule } from '@components/icon';
import { DirectivesModule } from '@directives/directives.module';
import { CartService } from '@services/cart-service/cart.service';
import { CartUpdateResult } from '@shared/types/cart.types';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

@Component({
  selector: 'product-card-grid',
  imports: [CommonModule, CsIconModule, DirectivesModule, ButtonCtaComponent],
  templateUrl: './product-card-grid.component.html',
})
export class ProductCardGridComponent {
  @Input() products: Array<any> = [];
  @Input() productsInCart: { [key: string]: number } = {};
  @Input() cartItems: any[] = [];
  @Input() showRemoveProductIcon: boolean = true;
  @Input() removeProductIcon: boolean = false;
  @Input() isShopRevampExperimentOn: boolean = false;
  @Input() section: string = 'productCardGrid';
  @Output() productClicked = new EventEmitter<any>();
  @Output() cartUpdated = new EventEmitter<CartUpdateResult>();
  @Output() removeProductClick = new EventEmitter<any>();

  constructor (
    private readonly cartService: CartService,
  ) {}

  viewProduct(product: any): void {
    this.productClicked.emit(product);
  }

  async addOrRemoveFromCart(product: any, action: string, event: Event, img?: HTMLImageElement): Promise<void> {
    event.stopPropagation();

    const result = await this.cartService.addOrRemoveFromCart(
      product,
      action,
      {
        img,
        productsInCart: this.productsInCart,
        cartItems: this.cartItems,
        section: this.section,
      }
    );

    if (result.success) {
      // Emitting cart update event so parent component can handle store updates
      this.cartUpdated.emit({
        success: true,
        updatedQuantity: result.updatedQuantity,
        shouldUpdateStore: result.shouldUpdateStore,
        updatedProductsInCart: result.updatedProductsInCart
      });
    }
  }

  getProductQuantityInCart(product: any): number {
    const productId = product.objectId;
    return this.productsInCart[productId] ?? 0;
  }

  onRemoveProduct(product: any, event: Event): void {
    event.stopPropagation();
    this.removeProductClick.emit(product);
  }
}
